import { mapContentModules } from '../contentModuleMapper';

export const mapContentSection = async ({ content, settings, siteId, locale }): Promise<Content.ContentSection> => {
	try {
		return {
			documentType: content?.contentType,
			content: {
				properties: {
					title: content.properties.title,
					content: await mapContentModules(content.properties.content?.items, siteId, locale),
				},
			},
			settings: {
				properties: {
					width: settings.properties.width,
					background: settings.properties.background || null,
				},
			},
		};
	} catch (e) {
		throw new Error(`Could not map Content Section \nCause: ${e}`, e);
	}
};
